import React from "react";

const Summarised = () => {
  return (
    <svg
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="4.74296"
        height="1.04437"
        rx="0.522187"
        transform="matrix(0.722895 -0.690958 0.722895 0.690958 2.81641 3.27734)"
        fill="#023A4A"
      />
      <rect
        width="4.74296"
        height="1.04437"
        rx="0.522186"
        transform="matrix(0.722895 0.690958 -0.722895 0.690958 0.755859 0.000976562)"
        fill="#023A4A"
      />
    </svg>
  );
};

export default Summarised;
